import { useClientAds } from "api/Client/ads";
import { useEffect, useRef, useState } from "react";

export default function ClientNotificationHomePage() {
  const { data: ads, isFetching, isSuccess, isError } = useClientAds();

  if (isError || !isSuccess || ads.data.length === 0) return null;

  return <NewsTicker ads={ads.data} />;
}

const NewsTicker = ({ ads }) => {
  const text = ads
    .map((ad) => `${ad.title}: ${ad.description}`)
    .join("    •    ");

  const contentRef = useRef(null);
  const wrapperRef = useRef(null);
  const [duration, setDuration] = useState(60);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!contentRef.current || !wrapperRef.current) return;
    const contentWidth = contentRef.current.scrollWidth;
    const wrapperWidth = wrapperRef.current.clientWidth || 1;
    const pxPerSecond = 50;
    const neededSeconds = (contentWidth + wrapperWidth) / pxPerSecond;
    const final = Math.max(10, Math.min(300, neededSeconds));
    setDuration(final);
  }, [text]);

  return (
    <div className="px-4 w-full max-w-6xl mx-auto">
      <div
        ref={wrapperRef}
        className="w-full overflow-hidden bg-gray-900 text-white_ p-2 mt-8 mx-auto rounded-lg border border-mainLight"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="ticker" style={{ direction: "rtl" }}>
          <div
            className="ticker__content flex text-nowrap"
            ref={contentRef}
            style={{
              // display: "inline-block",
              // whiteSpace: "nowrap",
              animation: `tickerMove ${duration}s linear infinite`,
              animationPlayState: isPaused ? "paused" : "running",
            }}
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        </div>

        <style>{`
          .ticker {
            position: relative;
            overflow: hidden;
            width: 100%;
          }

          @keyframes tickerMove {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(150%); }
          }

          
        `}</style>
      </div>
    </div>
  );
};

// إزالة الوسوم HTML من النص
function stripHtml(html) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
}
